module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-light-gray@2x-497776e608dd5156f747bffb37b25f85.png";